import { render, staticRenderFns } from "./SignupWaitingApprove.vue?vue&type=template&id=1b904ba5&scoped=true&"
import script from "./SignupWaitingApprove.vue?vue&type=script&lang=ts&"
export * from "./SignupWaitingApprove.vue?vue&type=script&lang=ts&"
import style0 from "./SignupWaitingApprove.vue?vue&type=style&index=0&id=1b904ba5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b904ba5",
  null
  
)

export default component.exports